import { useEffect, useRef } from 'react';
import './App.css';
import Footer from './components/Footer';
import Home from "./pages/Home"
import LocomotiveScroll from 'locomotive-scroll';
import { ScrollTrigger } from 'gsap/all';
import gsap from 'gsap';
gsap.registerPlugin(ScrollTrigger)


function App() {
  // const containerRef = useRef()
  let scroll
  // document.body.addEventListener("wheel", e => e.stopImmediatePropagation());
  // document.body.addEventListener("touchstart", e => e.stopImmediatePropagation());
  useEffect(() => {
    if (window.innerWidth > 600) {
      window.addEventListener("load", function () {
        scroll = new LocomotiveScroll({
          el: document.getElementById('main'),
          smooth: true,
          lerp: 0.03, // Linear Interpolation, 0 > 1 // Try 0.01
          multiplier: 1.4,
          scrollbarContainer: false,
          reloadOnContextChange: true,
          touchMultiplier: 2,
          smartphone: {
            smooth: true
          },
          tablet: {
            smooth: true
          },

        });

        scroll.on("scroll", ScrollTrigger.update);
        ScrollTrigger.scrollerProxy(document.getElementById('main'), {
          scrollTop(value) {
            return arguments.length
              ? scroll.scrollTo(value, 0, 0)
              : scroll.scroll.instance.scroll.y;
          },
          getBoundingClientRect() {
            return {
              top: 0,
              left: 0,
              width: window.innerWidth,
              height: window.innerHeight,
            };
          },
          // pinType: document.getElementById('main').style.transform ? "transform" : "fixed",
        });
        ScrollTrigger.addEventListener("refresh", () => scroll.update());
        ScrollTrigger.refresh()

      })
    }

  })
  return (
    <div id='main'
      data-scroll-container
    >
      <Home />
      <Footer />
    </div>
  );
}

export default App;
